// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__14ZtQ","row":"Node_row__2ud_6","label":"Node_label__23hFH","footer":"Node_footer__2H7gy"};